var _rect, _path, _rect2, _path2, _path3, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#F7FBF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16C11 15.7239 11.2239 15.5 11.5 15.5H23V16.5H11.5C11.2239 16.5 11 16.2761 11 16Z",
    fill: "#C7E3C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 13,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#C7E3C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 16C11 15.7239 11.2239 15.5 11.5 15.5H17H18V23.5H23V24.5H17.5C17.2239 24.5 17 24.2761 17 24V16.5H11.5C11.2239 16.5 11 16.2761 11 16Z",
    fill: "#43A047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 21C23.4477 21 23 21.4477 23 22V26C23 26.5523 23.4477 27 24 27H28C28.5523 27 29 26.5523 29 26V22C29 21.4477 28.5523 21 28 21H24ZM25.5 22.5C25.5 22.2239 25.7239 22 26 22C26.2761 22 26.5 22.2239 26.5 22.5V23.5H27.5C27.7761 23.5 28 23.7239 28 24C28 24.2761 27.7761 24.5 27.5 24.5H26.5V25.5C26.5 25.7761 26.2761 26 26 26C25.7239 26 25.5 25.7761 25.5 25.5V24.5H24.5C24.2239 24.5 24 24.2761 24 24C24 23.7239 24.2239 23.5 24.5 23.5H25.5V22.5Z",
    fill: "#43A047"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E6EAEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBottom);
export default __webpack_public_path__ + "static/media/AddBottom.9d7c398a89b36000555d3180bae7325f.svg";
export { ForwardRef as ReactComponent };